export const findTeam = (object, key) => {
  //console.log("IN FIND TEAM " + JSON.stringify(object))
  var value;
  Object.keys(object).some(function (k) {
    if (k === key) {
      value = object[k];
      return true;
    }
    return false;
  });
  return value;
};

export const getUsersCards = async (username) => {
  try {
    // TODO: Replace with your new AWS API Gateway URL
    const API_GATEWAY_URL =
      "https://ztzb4a26ej.execute-api.eu-west-2.amazonaws.com/Prod";

    const [ownedCardsResponse, wantedCardsResponse] = await Promise.all([
      fetch(
        `${API_GATEWAY_URL}/getOwnedCards?userName=${username || "jinky32"}`
      ),
      fetch(
        `${API_GATEWAY_URL}/getWantedCards?userName=${username || "jinky32"}`
      ),
    ]);
    const ownedCards = await ownedCardsResponse.json();
    const wantedCards = await wantedCardsResponse.json();
    // //console.log(ownedCards, 'ownedCards');
    // //console.log(wantedCards, 'wantedCards');
    return {
      ownedCards: ownedCards,
      wantedCards: wantedCards,
    };
    //   setExample((prevcontext => {
    //     return {
    //       ...prevcontext,
    //       age: 51,
    //       dataLoaded: true,
    //       ownedCards: ownedCards,
    //       wantedCards: wantedCards,
    //       //     nonAuthenticatedUsersWantedCards: [],
    //       // nonAuthenticatedUsersOwnedCards: []
    //     }
    //   }))
  } catch (err) {
    throw err;
  }
};

const API_GATEWAY_URL =
  "https://ztzb4a26ej.execute-api.eu-west-2.amazonaws.com/Prod";

export const getEbayListings = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.set("status", filters.status);
  if (filters.set_name) params.set("set_name", filters.set_name);
  if (filters.card_name) params.set("card_name", filters.card_name);
  if (filters.psa_grade) params.set("psa_grade", filters.psa_grade);
  const response = await fetch(
    `${API_GATEWAY_URL}/getEbayListings?${params.toString()}`
  );
  return response.json();
};

export const getWantList = async () => {
  const response = await fetch(`${API_GATEWAY_URL}/getWantList`);
  return response.json();
};

export const getSoldHistory = async (setName, cardName, psaGrade) => {
  const params = new URLSearchParams({ history: "true" });
  if (setName) params.set("set_name", setName);
  if (cardName) params.set("card_name", cardName);
  if (psaGrade) params.set("psa_grade", psaGrade);
  const response = await fetch(
    `${API_GATEWAY_URL}/getEbayListings?${params.toString()}`
  );
  return response.json();
};

export const importWantList = async (sheetNames = []) => {
  const response = await fetch(`${API_GATEWAY_URL}/importWantList`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(
      sheetNames.length > 0
        ? { action: "import", sheetNames }
        : { action: "import" }
    ),
  });
  return response.json();
};

export const getSheetNames = async () => {
  const response = await fetch(`${API_GATEWAY_URL}/importWantList`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "listSheets" }),
  });
  return response.json();
};
